import { createStore } from "vuex";

const localStorageKey =
  "DJsdfg-2352LLDSF-dfglñdskfgiu38r_[22334ews34>YUVASZghsvdV";

export default createStore({
  state: {
    isAuthenticated: false,
    role: "",
    username: "",
    token: "",
    dateFrom: "",
    dateTo: "",
    logo: "",
    code: "",
    selectedCliente: "ALL",
    selectedCisterna: "ALL",
    dateFromFilters: "",
    dateToFilters: "",
  },
  getters: {},
  mutations: {
    setIsAuthenticated(state, value) {
      state.isAuthenticated = value;
      localStorage.setItem(localStorageKey, JSON.stringify(state));
    },
    setUsername(state, value) {
      state.username = value;
      localStorage.setItem(localStorageKey, JSON.stringify(state));
    },
    setToken(state, value) {
      state.token = value;
      localStorage.setItem(localStorageKey, JSON.stringify(state));
    },
    setRole(state, value) {
      state.role = value;
      localStorage.setItem(localStorageKey, JSON.stringify(state));
    },
    setLogo(state, value) {
      state.logo = value;
      localStorage.setItem(localStorageKey, JSON.stringify(state));
    },
    setCode(state, value) {
      state.code = value;
      localStorage.setItem(localStorageKey, JSON.stringify(state));
    },
    setDateRange(state, { dateFrom, dateTo }) {
      state.dateFrom = dateFrom;
      state.dateTo = dateTo;
      localStorage.setItem(localStorageKey, JSON.stringify(state));
    },
    setFilters(
      state,
      { selectedCliente, selectedCisterna, dateFromFilters, dateToFilters }
    ) {
      state.selectedCliente = selectedCliente;
      state.selectedCisterna = selectedCisterna;
      state.dateFromFilters = dateFromFilters;
      state.dateToFilters = dateToFilters;
      localStorage.setItem(localStorageKey, JSON.stringify(state));
    },
    // Agregar una mutación para inicializar el estado desde localStorage al cargar la página
    initializeStateFromLocalStorage(state) {
      const storedState = localStorage.getItem(localStorageKey);
      if (storedState) {
        Object.assign(state, JSON.parse(storedState));
      }
    },
  },
  actions: {
    initializeStateFromLocalStorage({ commit }) {
      commit("initializeStateFromLocalStorage");
    },
    updateDateRange({ commit }, { dateFrom, dateTo }) {
      commit("setDateRange", { dateFrom, dateTo });
    },
    updateFilters({ commit }, payload) {
      commit("setFilters", payload);
    },
  },
});
